export class StudentSearchSubmitNewStudentRequest {
  firstName: string;
  middleName: string;
  lastName: string;
  gender: number | string | { value: number };
  dob: Date;

  streetName: string;
  streetNumber: string;
  apartmentNumber: string;
  city: string;
  homeBorough: string;
  state: number | { value: number };
  zip: string;

  guardianRelationship: number | { value: number };
  guardianFirstName: string;
  guardianLastName: string;
  guardianEmail?: string;
  guardianWorkPhoneNumber: string;
  guardianCellPhoneNumber: string;
  guardianHomePhoneNumber?: string;
  guardianSpokenLanguageCode: string;
  guardianWrittenLanguageCode: string;

  homeDistrict: string;
  schoolDistrict: string;
  bypassDuplicateCheck: boolean;
  studentSk: string;
  guardianId: string;
  reasonforReferral: number[];
  addedBy: string;

  email?: string; // student email address
  phoneNumber?: string; // student phone number

  constructor(newStudent: any) {
    // Student Information
    this.firstName = newStudent?.firstName;
    this.middleName = newStudent?.middleName;
    this.lastName = newStudent?.lastName;
    this.gender = (newStudent?.gender as { value: number })?.value;
    this.dob = newStudent?.dob;
    this.email = newStudent?.studentEmail;
    this.phoneNumber = newStudent?.studentPhoneNumber;

    // Student housing
    this.streetNumber = newStudent?.streetNumber;
    this.streetName = newStudent?.streetName;
    this.homeBorough = newStudent?.homeBorough?.value;
    this.apartmentNumber = newStudent?.apartmentNumber;

    this.city = newStudent?.city;
    this.state = newStudent?.state?.value;
    this.homeDistrict = newStudent?.homeDistrict?.value;
    this.zip = newStudent?.zip;

    // Guardian Information
    this.guardianRelationship = newStudent?.guardianRelationship?.value;
    this.guardianFirstName = newStudent?.guardianFirstName;
    this.guardianLastName = newStudent?.guardianLastName;
    this.guardianCellPhoneNumber = newStudent?.guardianCellPhone;
    this.guardianWorkPhoneNumber = newStudent?.guardianWorkPhone;
    this.guardianHomePhoneNumber = newStudent?.guardianHomePhone;

    this.guardianSpokenLanguageCode = newStudent?.guardianSpokenLanguage?.value;
    this.guardianWrittenLanguageCode =
      newStudent?.guardianWrittenLanguage?.value;
    this.guardianEmail = newStudent?.guardianEmail;

    // Additional Information
    this.schoolDistrict = newStudent?.homeDistrict?.value;
    this.studentSk = newStudent?.studentSk;
    this.guardianId = newStudent?.guardianId;
    this.reasonforReferral = newStudent?.reasonforReferral;
  }

  readonly id: string = '';
}
